export const env = "https://www.swipequotes.com:4200/"
//export const env = "http://localhost:4200/"